<template>
  <div id="content" class="startup_page">
    <ConfirmModal :dialogVisible='showConfirmDialog' @close="showConfirmDialog = false" @confirmed="confirmDelete($event)" message="Are you sure ? This action can't be canceled." ></ConfirmModal>

      <div class="content_div stats">
        <h1 class="customH2">My scouting campaigns</h1>
        <div class="loaderInnopearl " v-if="loading">
          <div class="loaderInnopearlInner">
            <img :src="require('@/assets/loaderInnopearl.svg')" alt="">
            <span>Loading in progress</span>
          </div>

        </div>
        <div class="row assessmentsList" v-if="my_linkplus.length > 0">
           <div class="col-12 filter" v-for="(linkp,f) in my_linkplus" :key="f">
            <div class="filter_info">
              <div class="zone_input_header">
                <span class="zone_input_name">
                  <router-link :to="'/manage_link_plus/'+linkp._id.$oid" >
                    {{linkp.name}}
                  </router-link>
                  <router-link :to="{ 'path': '/manage_link_plus/'+linkp._id.$oid, 'hash' : '#submitedStartup' }" >
                      <span class="isnew" v-if="linkp.newApplication">NEW</span>
                  </router-link>

                </span>
                <br/>
              </div>

            </div>
            <div class="actions">
              <div class="other_actions">

                  <a class="button" :href="this.apiUrl+'/beautiful_qrcode_file/'+linkp.access_id.$oid" v-if="linkp.access_id" >
                    <img :src="require('@/assets/blueDownload.svg')" alt=""/>

                  </a>


                    <router-link class="button" :to="'/manage_link_plus/'+linkp._id.$oid" >
                        <img :src="require('@/assets/eyeInno.svg')" alt=""/>
                    </router-link>

                  <button type="button" class="button" name="button" @click="deleteLink(linkp._id.$oid)">
                    <img :src="require('@/assets/trashInno.svg')" alt=""/>
                  </button>

              </div>

            </div>


          </div>

        </div>
        <div class="row" v-else>
          <div class="alert alert-warning text-center" v-if="!loading">
             You don't have any Link+<sup>©</sup> yet
          </div>
        </div>

        <!-- <div class="row actions">
            <div class="col-12 text-center">
                <button type="button" class="next_step_btn" name="button" @click="addFilter">Add new</button>
            </div>
        </div> -->
      </div>
  </div>
</template>
<script>
import api from '../tools/api';
// import router from '@/router'
import ConfirmModal from '@/components/modals/ConfirmModal.vue'

 import { toast } from 'vue-sonner'
export default {
  components: {
    ConfirmModal
  },
  name: 'List_My_Filter',
  data() {
    return {
      loading:false,
      pageInfo: {
        mainTitle : "My Link+ space",
        subTitle : "View all campaigns",
      },
      apiUrl: process.env.VUE_APP_API_URL,
      my_linkplus: [],
      dialog: false,
      showConfirmDialog: false,
      asked_for_delete : null,
    }
  },
  methods:{

    deleteLink(v){
      this.showConfirmDialog = true;
      this.asked_for_delete = v;
    },
    confirmDelete(v){
      console.log(v);
      this.showConfirmDialog = false;
      var t = this.asked_for_delete;
      api.post(process.env.VUE_APP_API_URL+"/restrict/my_linkplus_delete",
          {
              linkplus: this.asked_for_delete,
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          this.$store.commit('UPDATE_LINKPLUS_REMOVE',t);
          this.listFilter();

        }).catch( (e) => {
          console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
      console.log(this.asked_for_delete);
        this.asked_for_delete = null;
    },
      listFilter(){
        this.loading = true;
        api.get(process.env.VUE_APP_API_URL+"/restrict/list_mylinkplus").then( (r) => {
          // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
          // console.log();
          // var temp = _.merge(this.candidatespool, r.data)
          console.log("FILTERS");
          console.log(r.data);
          this.my_linkplus = r.data;

          this.loading=false;

        }).catch( (e) => {
          this.loading=false;
          console.log(e);
           toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });
      }
  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo);
     this.loading =true;
     api.get(process.env.VUE_APP_API_URL+"/restrict/list_mylinkplus").then( (r) => {
       // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
       // console.log();
       // var temp = _.merge(this.candidatespool, r.data)
       console.log("FILTERS");
       console.log(r.data);
       this.my_linkplus = r.data;
       this.loading =false;

     }).catch( (e) => {
       this.loading =false;
       console.log(e);
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
   });
  },


}
</script>
<style scoped>

.startup_page{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}
.chart-container {
  position: relative;
}

.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 200px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
  display:inline-block;
}

.prev_step_btn,
.prev_step_btn:hover{
  border: 1px solid #3783C5;
  border-radius: 200px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
    text-decoration: none;
}

.canvasjs-chart-credit{
  display:none;
}

.chartDiv{
  margin:auto;
}
.col-center{
  text-align: center;
}
.zone_input_name{
  text-align: left;
  font-size: 18px;
  line-height: 21px;
}
.zone_input_name a{
  color: #000 !important;
}
.zone_input_header{
  display:flex;
  align-items: center;
}
.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
box-sizing: border-box;
margin-top:10px;
margin-bottom: 20px;
height: 40px;
padding: 5px;
}
@media screen and (max-width: 990px){
.innopearl_input{
  width:100%;
  margin-left:0;
}
}

.tblue{
  color:#3783C5;
}
.customH2{
    color: #3783C5;
    font-size:21px;
    text-transform:uppercase;
    margin-bottom:20px;
}
.v-field--variant-filled .v-field__overlay{
  background:#FFF !important;
}

.dateSelectors{
  display:flex;
  flex-direction:row;
  gap:20px;
}
.dateSelectors label{
  flex:1;
}
.next_step_btn svg{
  margin-right:15px;
}
.filterBtnDiv{
  margin-top:20px;
}
@media screen and (max-width:800px){
  .dateSelectors{
    display:flex;
    flex-direction:column;
    gap:20px;
  }
  .dateSelectors label{
    width:100%;
  }
}



.filter{
  padding-top:25px;
  padding-bottom:25px;
  border-bottom:1px solid #fff;
  display:flex;
  align-items: center;
}
.filter_info{
  flex:1;
}
.details{
  font-size:12px;
  line-height: 15px;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
}

.actions{
  margin-top:20px;
}
.remove{
  border:1px solid #C63221;
  color:#C63221;
  background:#FFF;
  padding:5px 10px;
  font-size:12px;
  line-height: 15px;
  margin-left:10px;
  align-self: center;
  border-radius:50px;
}


.filter{
  gap:20px;
}

.isnew{
  background:#B38D2F;
  color:#FFF;
  padding:3px 10px;
  font-size:12px;
  border-radius:50px;
  margin-left:10px;
}
.dfc{
  display: flex;
  align-content: center;
  align-items: center;
}
.asc{
  align-self: center;
}

.assessmentsList{
  background: #3783C512;
  padding: 25px;
  border-radius: 20px;

}


.actions{
  display:flex;
  align-items: center;
  gap:20px;
  margin-top:0px;
}
.actions .button{
  padding-left:15px;
  padding-right: 15px;
  padding-top:5px;
  padding-bottom: 5px;
}

.actions .button.unavailalbr{
  padding-left:15px;
  padding-right: 15px;
  padding-top:5px;
  padding-bottom: 5px;
  opacity:.3;
}



.other_actions{
  background:#FFF;
  padding:5px;
  border-radius:20px;
}

.other_actions.innospeacial {

  padding:10px !important;
  border-radius:50%;
}

.innospeacial img{
  height:25px !important;
  width:25px !important;
    object-fit:contain;
}

</style>
<style>
.dp__pointer{
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}
.dp__input_icon {
  cursor: pointer;
  position: absolute;
  top: 50%;

  left: 10px !important;
}
.input-slot-image{
  width:100% !important;
  height:100% !important;
  object-fit: contain;
  object-position: center;
  display: block;
}


</style>
